import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";

import { useStore } from "../../store";
import LogoMarkLoader from "../../lib/ui/components/logo-mark-loader/LogoMarkLoader";

const ProtectedRoute = () => {
  const user = useStore((state) => state.uid);
  const onboardingRequired = useStore((state) => state.onboardingRequired);
  const company = useStore((state) => state.company);
  const isLoading = useStore((state) => state.userLoading);
  const location = useLocation();

  const companyInactive =
    company &&
    typeof company === "object" &&
    company.status === "inactive";

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-[85vh]">
        <LogoMarkLoader />
      </div>
    );
  }

  if (
    user &&
    onboardingRequired &&
    location.pathname !== "/onboarding/company"
  ) {
    return <Navigate to={`/onboarding/company`} replace />;
  }

  if (
    user &&
    !onboardingRequired &&
    companyInactive &&
    location.pathname !== "/account/inactive"
  ) {
    return <Navigate to="/account/inactive" replace />;
  }

  if (!user) {
    const redirectUrl = location.pathname + location.search;
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(redirectUrl)}`}
        replace
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
